import React from 'react';
import PropType from 'prop-types';
import connect from './connect';
import Table from './table';

class PageTemplateTable extends React.Component {
  render() {
    const { page_template_manager } = this.props;
    return (
      <Table
        {...page_template_manager}
        columns={[
          { header: 'Title', accessor: 'title', width: 100 },
          { header: 'Component Name', accessor: 'reactComponentName', width: 140 },
          { header: 'Description', accessor: 'description' }
        ]}
        selected_columns={[
          'title', 'description', 'reactComponentName'
        ]}
        onFetch={this.props.fetchPageTemplates}
      />
    );
  }
}

export default connect(PageTemplateTable);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/page-template-table.js